import { render, staticRenderFns } from "./emba.vue?vue&type=template&id=8ab6c0e8"
import script from "./emba.vue?vue&type=script&lang=js"
export * from "./emba.vue?vue&type=script&lang=js"
import style0 from "./emba.vue?vue&type=style&index=0&id=8ab6c0e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports